/** Hostname des Supabase-Storage (siehe images.remotePatterns in next.config.ts). */
const SUPABASE_HOST = "pbdoaugkbmhkrdqasrcs.supabase.co";

/**
 * true, wenn next/image die Quelle optimieren darf: eigene Domain
 * (site-relativ) oder öffentlicher Supabase-Storage. Alles andere
 * (z. B. von Hand eingetragene Fremd-URLs) bleibt ein plain <img>.
 */
export function canOptimizeImage(src: string | null | undefined): src is string {
  if (!src) return false;
  if (src.startsWith("/")) return true;
  try {
    const u = new URL(src);
    return u.protocol === "https:" && u.hostname === SUPABASE_HOST && u.pathname.startsWith("/storage/v1/object/public/");
  } catch {
    return false;
  }
}
